import React from 'react';
import styles from './Banner.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import profile from '../../Images/image 12.png';
import resume from '../../resume/Joney Resume (2).pdf';

const Banner = () => {
  return (
    <div style={{ textAlign: 'center' }} className={styles.banner}>
      <div className="row d-flex align-items-center">
        <div className="col-md-6 mt-5 pl-5 text-left">
          <h1>
            Joney <br />
            <span>Talukdar .</span>
          </h1>
          <h3>Junior Front-End Developer</h3>
          <button>
            <a className={styles.link} href={resume} download>
              <FontAwesomeIcon
                style={{ marginRight: '10px' }}
                icon={faDownload}
              />{' '}
              Get Resume
            </a>
          </button>
        </div>
        <div className="col-md-6 mt-3">
          <img className="img-fluid w-75" src={profile} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Banner;
